<div class="overlay" *ngIf="show">
    <div class="col-sm-3 p-2 popup-container">
        <loading-spinner></loading-spinner>
        <div class="card card-1 border border-primary p-1 z-depth-1">
            <div class="card-body text-center">
                <h5 class="card-title"><b>{{header}}</b></h5>
                <p class="card-text">
                    {{message}}
                </p>
                <div>
                    <button mdbBtn mdbWavesEffect (click)="onClickButton1($event)" color="blue" class="btn btn-sm">{{button1Text}}</button>
                    <button mdbBtn mdbWavesEffect (click)="onClickButton2($event)" color="blue" class="btn btn-sm">{{button2Text}}</button>
                </div>
            </div>
        </div>
    </div>
</div>